import React, { useCallback, useEffect, useState } from "react";

import { Tooltip } from "flowbite-react";
import { useNavigate, useParams } from "react-router-dom";
import { getDocBookShelf } from "../api/document";
import PageContainer from "../components/PageContainer";
import { toImagePath, toPascalCase } from "../utils/globalFunctions";

const DocBookShelf = () => {
  const { grouptype } = useParams();
  const navigate = useNavigate();
  const [pageData, setPageData] = useState([]);

  console.log("grouptype", grouptype);

  const getData = useCallback(
    () =>
      getDocBookShelf()
        .then((res) => {
          const mapDoc = res.find(
            (item) => item.grouptype.toLowerCase() === grouptype.toLowerCase()
          );

          if (mapDoc) {
            setPageData(mapDoc);
          }
        })
        .catch((err) => console.log(err)),
    [setPageData, grouptype]
  );

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <PageContainer
      title={toPascalCase(pageData?.Titlename ?? "")}
      bgImg="/images/docs/infographic-banner.png"
    >
      <section>
        <div className="container pt-10 mx-auto max-w-[800px]">
          <div className="grid md:grid-cols-3 sm:grid-cols-2 gap-5 justify-center">
            {pageData?.docsgrup?.map((item, index) => (
              <Tooltip content={item.title} position="top" key={index}>
                <div
                  className="w-[200px] h-[250px] rounded-lg overflow-hidden shadow-lg cursor-pointer"
                  onClick={() => navigate(`/docpdf/view/${item.pdflink._id}`)}
                >
                  <img
                    src={toImagePath(item.cover.path)}
                    alt={item.title}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                  />
                </div>
              </Tooltip>
            ))}
          </div>
        </div>
      </section>
    </PageContainer>
  );
};

export default DocBookShelf;
